import { render, staticRenderFns } from "./MainHeaderPlatB.vue?vue&type=template&id=b921aa8a&scoped=true"
import script from "./MainHeaderPlatB.vue?vue&type=script&lang=js"
export * from "./MainHeaderPlatB.vue?vue&type=script&lang=js"
import style0 from "./MainHeaderPlatB.vue?vue&type=style&index=0&id=b921aa8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b921aa8a",
  null
  
)

export default component.exports